module.exports = __webpack_public_path__ + "8050a4697c44836d1ad209325244de85.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-14.png
// module id = 2248
// module chunks = 0